define('viewmodels/questions/questionContent',['questionContent/questionContent'],
	function (QuestionContent) {
	    "use strict";

	    return new QuestionContent();
	});
